import { nsSimCard } from '@/app/i18n/namespaces';

const SIM_CARDS_STATUS = {
    UNKNOWN:
        { name: 'UNKNOWN', nameLowCase: 'unknown', entity: 'status.UNKNOWN', namespace: nsSimCard, variant: 'gray' },
    INACTIVE:
        { name: 'INACTIVE', nameLowCase: 'inactive', entity: 'status.INACTIVE', namespace: nsSimCard, variant: 'blue' },
    PENDING_ACTIVATION:
        { name: 'PENDING_ACTIVATION', nameLowCase: 'pending-activation', entity: 'status.PENDING_ACTIVATION', namespace: nsSimCard, variant: 'blue' },
    PREACTIVATED:
        { name: 'PREACTIVATED', nameLowCase: 'preactivated', entity: 'status.PREACTIVATED', namespace: nsSimCard, variant: 'light-green' },
    ACTIVATED:
        { name: 'ACTIVATED', nameLowCase: 'activated', entity: 'status.ACTIVATED', namespace: nsSimCard, variant: 'green' },
    PENDING_SUSPENSION:
        { name: 'PENDING_SUSPENSION', nameLowCase: 'pending-suspension', entity: 'status.PENDING_SUSPENSION', namespace: nsSimCard, variant: 'orange' },
    SUSPENDED:
        { name: 'SUSPENDED', nameLowCase: 'suspended', entity: 'status.SUSPENDED', namespace: nsSimCard, variant: 'orange' },
    PENDING_TERMINATION:
        { name: 'PENDING_TERMINATION', nameLowCase: 'pending-termination', entity: 'status.PENDING_TERMINATION', namespace: nsSimCard, variant: 'red' },
    TERMINATED:
        { name: 'TERMINATED', nameLowCase: 'terminated', entity: 'status.TERMINATED', namespace: nsSimCard, variant: 'red' },
    PENDING_REPLACE:
        { name: 'PENDING_REPLACE', nameLowCase: 'pending-replace', entity: 'status.PENDING_REPLACE', namespace: nsSimCard, variant: 'orange' }
};

export default SIM_CARDS_STATUS;